import type { AxiosPromise } from 'axios'

import type { StoreApiModel, StoreLogoTheme, StoreModel } from '@/types/StoreModel'
import request from '@/utils/request'

import type { LeafletApiModel } from './leaflets'

const STORES_API = '/api/stores'
type StoreUpdateApiPayload = Omit<StoreApiModel, 'leaflets'>

export function getAllShops(params?: Record<string, string>): AxiosPromise<StoreApiModel[]> {
  return request.get(STORES_API, { params })
}

export function getShop(shopId: StoreModel['id']): AxiosPromise<StoreApiModel> {
  return request.get(`${STORES_API}/${shopId}`)
}

export function postLeafletToStore(
  data: unknown,
  storeId: StoreModel['id'],
  watermark: boolean
): AxiosPromise<{ id: LeafletApiModel['id'] }> {
  return request.post(`${STORES_API}/${storeId}/leaflets${watermark ? '?watermark=true' : ''}`, data)
}

export function getShopLeaflets(storeId: StoreModel['id']): AxiosPromise<LeafletApiModel[]> {
  return request.get(`${STORES_API}/${storeId}/leaflets?type=ACTIVE`)
}

export function addNewShop(data: StoreApiModel): Promise<AxiosPromise<StoreApiModel['id']>> {
  return request.post(STORES_API, data)
}

export function editShop(data: StoreUpdateApiPayload): Promise<AxiosPromise<void>> {
  return request.put(`${STORES_API}/${data.id}`, data)
}

export function addShopLogo(data: FormData, storeId: StoreModel['id'], theme: StoreLogoTheme) {
  return request({
    url: `/api/stores/${storeId}/logo`,
    method: 'post',
    data,
    params: { theme }
  })
}

export function removeShop(shopId) {
  return request({
    url: `/api/stores/${shopId}`,
    method: 'delete'
  })
}

export function notifyShops(data) {
  return request({
    url: `/api/notifications`,
    method: 'post',
    data
  })
}

export function restoreShop(id) {
  return request({
    url: `/api/stores/${id}/restore`,
    method: 'post'
  })
}

export function getLeafletsSummary(id) {
  return request({
    url: `/api/stores/${id}/leaflets-summary`,
    method: 'get'
  })
}
